import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

const MainPageRedirection = lazyRouteComponent(() => import('@/_containers/main-page-redirection'));

export const Route = createFileRoute('/')({
  component: MainPageRedirection,
});
